// src/feature-module/SessionListener.tsx
import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { all_routes } from "./router/all_routes";

const WARNING_BEFORE_MS = 2 * 60 * 1000; // 2 minutes

const SessionListener = () => {
  const routes = all_routes;
  const navigate = useNavigate();
  const warnedRef = useRef(false);

  // useEffect(() => {
  //   const interval = setInterval(() => {
  //     const token = localStorage.getItem("authToken");
  //     const expiry = localStorage.getItem("token_expiry");

  //     if (!token || !expiry) return;

  //     const expiryTime = Number(expiry);
  //     const now = Date.now();
  //     const remaining = expiryTime - now;

  //     // ⚠️ 2-minute warning
  //     if (
  //       remaining <= WARNING_BEFORE_MS &&
  //       remaining > 0 &&
  //       !warnedRef.current
  //     ) {
  //       warnedRef.current = true;
  //       toast.warn("⚠️ Session expiring in 2 minutes. Please save your work.");
  //     }

  //     // ❌ Expired → immediate logout
  //     if (remaining <= 0) {
  //       clearInterval(interval);
  //       localStorage.clear();
  //       toast.info("Session expired. Please login again.");
  //       navigate("/");
  //       navigate(routes.login, { replace: true });
  //     }
  //   }, 1000); // every second (very cheap)

  //   return () => clearInterval(interval);
  // }, [navigate]);
useEffect(() => {
  let lastLoggedAt = 0;

  const interval = setInterval(() => {
    const token = localStorage.getItem("authToken");
    const expiry = localStorage.getItem("token_expiry");

    if (!token || !expiry) return;

    const expiryTime = Number(expiry);
    const now = Date.now();
    const remaining = expiryTime - now;

    // 🧪 Console log every 10 seconds
    if (now - lastLoggedAt >= 10_000) {
      lastLoggedAt = now;

      const minutes = Math.floor(remaining / 60000);
      const seconds = Math.floor((remaining % 60000) / 1000);

      console.log(
        `[SESSION] Remaining time: ${minutes}m ${seconds}s`
      );
    }

    // ⚠️ 2-minute warning
    if (
      remaining <= WARNING_BEFORE_MS &&
      remaining > 0 &&
      !warnedRef.current
    ) {
      warnedRef.current = true;
      toast.warn(
        "⚠️ Session expiring in 2 minutes. Please save your work."
      );
    }

    // ❌ Expired → immediate logout
    if (remaining <= 0) {
      clearInterval(interval);
      localStorage.clear();
      toast.info("Session expired. Please login again.");
      navigate(routes.login, { replace: true });
    }
  }, 1000);

  return () => clearInterval(interval);
}, [navigate]);

  return null;
};

export default SessionListener;
